// src/components/NotifBell.js — extracted from App.js
import React, { useState } from "react";
import { timeAgo } from "../lib/utils";

// ─── Bell / Notification Dropdown ────────────────────────────────────────────
export function NotifBell({ notifs, session, onMarkRead, onMarkAllRead, setView, setMarketTab, setAdminTab, setSellerDashTab }) {
  const [open, setOpen] = useState(false);
  const u = session?.user;
  const isAdmin = u?.role==="admin" || u?.roles?.includes("admin");
  const mine = (notifs||[]).filter(n => isAdmin ? (n.userId==="admin"||n.userId===u?.id) : n.userId===u?.id);
  const unread = mine.filter(n=>!n.read).length;

  const handleClick = (n) => {
    onMarkRead(n.id);
    if (n.link?.view) {
      if (n.link.view==="market" && n.link.tab && setMarketTab) setMarketTab(n.link.tab);
      if (n.link.view==="admin" && n.link.tab && setAdminTab) setAdminTab(n.link.tab);
      if (n.link.view==="seller-dash" && n.link.tab && setSellerDashTab) setSellerDashTab(n.link.tab);
      setView(n.link.view);
    }
    setOpen(false);
  };

  return (
    <div style={{position:"relative"}}>
      <button onClick={()=>setOpen(o=>!o)} style={{background:"none",border:"none",padding:"6px 8px",position:"relative",cursor:"pointer",display:"flex",alignItems:"center",color:"var(--ink2)"}}>
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/>
        </svg>
        {unread>0 && <span style={{position:"absolute",top:2,right:2,background:"var(--red)",color:"#fff",borderRadius:"50%",minWidth:15,height:15,fontSize:9,display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"'DM Mono',monospace",fontWeight:700,padding:"0 2px"}}>{unread>9?"9+":unread}</span>}
      </button>
      {open && (
        <>
          {/* Backdrop rendered via portal-like fixed div — must be high enough to escape header's stacking context */}
          <div style={{position:"fixed",inset:0,zIndex:9997}} onClick={()=>setOpen(false)}/>
          <div style={{position:"absolute",right:0,top:"calc(100% + 6px)",width:320,background:"#fff",border:"1.5px solid var(--bd)",borderRadius:12,boxShadow:"0 8px 32px rgba(0,0,0,.12)",zIndex:9999,overflow:"hidden"}}>
            <div style={{padding:"12px 16px",borderBottom:"1px solid var(--bd2)",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <span style={{fontFamily:"'DM Mono',monospace",fontSize:10,letterSpacing:"0.12em",color:"var(--ink2)"}}>NOTIFICATIONS</span>
              {unread>0 && <button onClick={()=>{onMarkAllRead();}} style={{background:"none",color:"var(--ink3)",fontSize:11,border:"none",cursor:"pointer",textDecoration:"underline"}}>Mark all read</button>}
            </div>
            <div style={{maxHeight:380,overflowY:"auto"}}>
              {mine.length===0 ? (
                <div style={{padding:"32px 16px",textAlign:"center",fontFamily:"'DM Mono',monospace",fontSize:11,color:"var(--ink3)"}}>No notifications yet</div>
              ) : [...mine].reverse().slice(0,25).map(n=>(
                <div key={n.id} onClick={()=>handleClick(n)} style={{padding:"12px 16px",borderBottom:"1px solid var(--bd2)",cursor:n.link?"pointer":"default",background:n.read?"transparent":"rgba(212,160,23,.05)",display:"flex",gap:10,alignItems:"flex-start",transition:"background .1s"}} onMouseOver={e=>{if(n.link)e.currentTarget.style.background="var(--bg2)";}} onMouseOut={e=>{e.currentTarget.style.background=n.read?"transparent":"rgba(212,160,23,.05)";}}>
                  <div style={{width:7,height:7,borderRadius:"50%",background:n.read?"transparent":"var(--gold)",flexShrink:0,marginTop:5,border:n.read?"none":"1.5px solid var(--gold)"}}/>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{fontSize:13,fontWeight:n.read?400:500,color:"var(--ink)",marginBottom:2,lineHeight:1.4}}>{n.title}</div>
                    <div style={{fontSize:12,color:"var(--ink3)",lineHeight:1.5}}>{n.body}</div>
                    <div style={{fontFamily:"'DM Mono',monospace",fontSize:9,color:"var(--ink3)",marginTop:4,letterSpacing:"0.06em"}}>{timeAgo(n.createdAt)}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
}

// ─── Auth Modal ───────────────────────────────────────────────────────────────
